import { render, staticRenderFns } from "./TabSupport.vue?vue&type=template&id=7faa6b62&scoped=true"
import script from "./TabSupport.vue?vue&type=script&lang=js"
export * from "./TabSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa6b62",
  null
  
)

export default component.exports